var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6666 5.83333L15.6666 15.1667L13.3333 15.1667L13.3333 5.83333L9.83329 5.83333L14.5 -5.09966e-07L19.1666 5.83333L15.6666 5.83333ZM7.49996 4.66581L7.49996 7.82641C6.04781 9.47172 5.16663 11.633 5.16663 14C5.16663 19.1547 9.34527 23.3333 14.5 23.3333C19.6546 23.3333 23.8333 19.1547 23.8333 14C23.8333 11.633 22.9521 9.47172 21.5 7.82641L21.5 4.66581C24.3337 6.79429 26.1666 10.1831 26.1666 14C26.1666 20.4433 20.9433 25.6667 14.5 25.6667C8.05669 25.6667 2.83329 20.4433 2.83329 14C2.83329 10.1831 4.66624 6.79429 7.49996 4.66581Z",
    fill: "#191A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6666 5.83333L15.6666 15.1667L13.3333 15.1667L13.3333 5.83333L9.83329 5.83333L14.5 -2.03986e-07L19.1666 5.83333L15.6666 5.83333Z",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/CheckOut.ff32c3b7f7926bbd1c0f0ff8b32455e4.svg";
export { ForwardRef as ReactComponent };